const typeAgent = [
  {
    id: "UTILISATEUR_CONNECTE_OBLIGATOIRE",
    libelle: "Utilisateur connecté obligatoire",
  },
  {
    id: "UTILISATEUR_CONNECTE",
    libelle: "Utilisateur connecté",
  },
  {
    id: "COMPOSANT_AGENT_ONLY",
    libelle: "Liste des agents",
  },
  {
    id: "VALEUR_PRECEDENTE",
    libelle: "Valeur précédente",
  },
];

export default typeAgent;
